import { useCallback, useEffect, useState } from 'react';
import APIAgent from './apiAgent';

const ENDPOINT = '/api/admin/docusign-forms';

export function useAdminDocusignForms() {
  const [forms, setForms] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [isAdmin, setIsAdmin] = useState(null);

  const refresh = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const data = await APIAgent.request(`${ENDPOINT}?include_inactive=true`, 'GET');
      setForms(Array.isArray(data?.forms) ? data.forms : []);
      setIsAdmin(true);
    } catch (err) {
      const msg = err?.message || '';
      if (msg.includes('403') || msg.includes('401') || msg.toLowerCase().includes('admin access required')) {
        setIsAdmin(false);
      } else {
        setError(msg || 'Failed to load DocuSign forms');
        // Do not mark non-admin for network/server failures; this causes false
        // "Access Denied" states for actual admins.
        setIsAdmin((prev) => (prev === false ? false : null));
      }
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const createFormVersion = useCallback(async (payload) => {
    await APIAgent.request(ENDPOINT, 'POST', payload);
    await refresh();
  }, [refresh]);

  const setFormActive = useCallback(async (templateId, isActive) => {
    await APIAgent.request(`${ENDPOINT}/${templateId}/active`, 'PUT', { is_active: isActive });
    await refresh();
  }, [refresh]);

  const updateForm = useCallback(async (templateId, payload) => {
    await APIAgent.request(`${ENDPOINT}/${templateId}`, 'PUT', payload);
    await refresh();
  }, [refresh]);

  return {
    forms,
    loading,
    error,
    isAdmin,
    refresh,
    createFormVersion,
    setFormActive,
    updateForm,
  };
}
